export default __webpack_public_path__ + "static/media/atlas-logo-white_placeholder_powered-by-outlogic.2731dd26.svg";